import { faMessage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import Alert from "./Alert";
import { getNbMessNoRead } from "../actions/contact";
import { tempAlWait } from "../helpers";
import { connect } from "react-redux";

class TchatBtn extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            ttl: '',
            desc: ''
        },
        nb: 0,
        isStart: true
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinueTchat != this.props.canContinueTchat) {
            if (this.props.canContinueTchat) {
                this.props.getNbMessNoRead();
                this.setState({
                    alert: tempAlWait()
                })
            }
        }

        if (prevProps.redNbNoRead != this.props.redNbNoRead) {
            this.setState({
                alert: this.props.redNbNoRead.alert,
                nb: this.props.redNbNoRead.datas,
                isStart: false
            })
            this.props.handleContinue();
        }

        if (prevState.alert != this.state.alert) {
            this.props.changeAlert(this.state.alert);
        }
    }
    
    render() {
        return <>
            <button
                title={`Contacter ${this.props.idtt.name}`}
                aria-label={`Contacter ${this.props.idtt.name}`}
                className={`ctcbtn ${this.props.openMessage && "ctcbtn--inactive"} dispAdmin`}
                id="btn-contact"
                onClick={() => this.props.handleTchat()}
            >
                <FontAwesomeIcon icon={faMessage} />
                <span className="ctcbtn__text">Contactez-nous</span>
                {
                    this.state.nb != 0 &&
                    <span className="ctcbtn__badge">{this.state.nb}</span>
                }
            </button>
        </>
    }
}

const mapStateToProps = state => {
    return {
        redNbNoRead: state.redNbNoRead
    }
}

const mapDispatchToProps = {
    getNbMessNoRead
}

export default connect(mapStateToProps, mapDispatchToProps)(TchatBtn);